import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { CookieService } from 'ngx-cookie-service';
import isEmpty from 'lodash-es/isEmpty';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "ngx-cookie-service/cookie-service/cookie.service";
export const GEO_LOCATION_CONFIG = new InjectionToken('GEO_LOCATION_CONFIG');
export class GeolocationService {
    constructor(config, httpClient, cookieService) {
        this.config = config;
        this.httpClient = httpClient;
        this.cookieService = cookieService;
        this.url = this.config.URL;
    }
    getGeoCode() {
        const cookieAka = this.cookieService.get(this.config.COOKIE_AKA);
        const cookieJar = this.cookieService.get(this.config.COOKIE_JAR);
        if (!isEmpty(cookieAka)) {
            console.log('geolocation using aka', this.config.COOKIE_AKA);
            return this.getGeoFromAkamaiCookie(cookieAka);
        }
        else if (!isEmpty(cookieJar)) {
            console.log('geolocation using jar', this.config.COOKIE_JAR);
            return this.getGeoFromCookie(cookieJar);
        }
        else {
            console.log('geolocation using url', this.url);
            if (this.geoDataCache) {
                console.log('geo: return the cached geo data');
                return of(this.geoDataCache);
            }
            else if (this.geoServiceSubject) {
                console.log('geo: return geo subject');
                return this.geoServiceSubject;
            }
            else {
                console.log('geo: create geo subject, call geo endpoint, return geo subject');
                this.geoServiceSubject = new Subject();
                this.httpClient.get(this.url).subscribe((geodata) => {
                    console.log('geo: received geo data, caching calling next on geo subject');
                    this.geoDataCache = geodata;
                    this.geoServiceSubject.next(geodata);
                });
                return this.geoServiceSubject;
            }
        }
    }
    getGeoFromCookie(cookie) {
        const geoip = JSON.parse(unescape(cookie));
        return of(geoip);
    }
    getGeoFromAkamaiCookie(cookie) {
        const geoip = JSON.parse(unescape(cookie));
        // lc to match existing format
        geoip.countryIsoCode = geoip.countryisocode = geoip.country.toLowerCase();
        // use iso->country map if it exists
        geoip.country = this.config.ISO_COUNTRY_MAP[geoip.country] || geoip.country;
        // use region map if it exists
        geoip.region = this.config.REGION_MAP[geoip.region] || geoip.region;
        // convert Akamai format: 'Los Angeles' to `los+angeles'
        geoip.metro = geoip.metro.toLowerCase().replace(' ', '+');
        // Akamai sends ranges/lists of zip codes
        // example: `91501-91508+91510+91521-91523+91526`
        // only get the first zip code
        const match = geoip.zipCode.match(/^\d+/);
        if (match) {
            geoip.zipCode = match[0];
        }
        return of(geoip);
    }
}
GeolocationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GeolocationService_Factory() { return new GeolocationService(i0.ɵɵinject(GEO_LOCATION_CONFIG), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CookieService)); }, token: GeolocationService, providedIn: "root" });
